import React from 'react';
import PropTypes from 'prop-types';

export default class AppStatusIndicator extends React.Component {
  static propTypes = {
    status: PropTypes.oneOf(['APPROVED', 'DRAFT', 'INACTIVE', 'LIVE', 'REJECTED', 'UNDER_REVIEW', 'WITHDRAWN']),
    large: PropTypes.bool,
    inactiveStatus: PropTypes.string
  }

  static defaultProps = {
    status: 'DRAFT',
    large: false
  }

  formatStatusDisplay(status) {
    //UNDER_REVIEW is the outlier
    if (status === "INACTIVE" && this.props.inactiveStatus === "Expired Certificate") {
      return "INACTIVE - EXPIRED CERTIFICATE";
    }
    return status.replace(/_/g,' ');
  }

  render() {
    return(
      <div className={`app-status-indicator ${this.props.status.toLowerCase()} ${this.props.large? 'large':''}`}>
        <span className="sr-only">Status: </span>{this.formatStatusDisplay(this.props.status)}
      </div>
    )
  }
}
